<app-news-layout
  title="KPIs"
  img="/assets/img/game/kpi.svg"
  (closeClick)="onCloseClick()"
>
  <div class="kpi-wrap">
    <app-stats *ngIf="game_state" [values]="values"></app-stats>
  </div>
</app-news-layout>
